<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-30 16:35:26
 * @FilePath: \mrc-base-server-view\src\views\module_func_manage\index.vue
-->
<template>
  <!-- 模块功能管理 -->
  <v-card v-if="$route.name === 'module_func_manage'">
    <!-- 增加按钮 -->
    <mrc_ess_addBtn v-btnAuth="['add-module', 'add-function']"
                    :list="addList"></mrc_ess_addBtn>
    <v-skeleton-loader :boilerplate="false"
                       type="table"
                       :tile="false"
                       :loading="showSkeleton"
                       transition="fade-transition"
                       class="mx-auto">
      <v-card-text class="pa-0 pb-4 px-8">
        <!-- <product v-for="(item,index) in productData"
                 class="product213"
                 :key='index'
                 @delData='delData'
                 :obj='item'>
        </product> -->
        <v-sheet class="d-flex pt-6 pb-4 px-2 justify-space-between"
                 style="color: rgba(0,0,0,.6)">
          <v-sheet class="ml-7 d-flex align-center text--secondary">
            <span class="px-1">{{ $t('label_product') }}</span>/<span class="px-1">{{ $t('label_The_module') }}</span>/
            <span class="d-flex align-center px-1 text--secondary">
              <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                               icon-class="diamond02"></mrc_ess_svgIcon>{{ $t('label_function') }}
            </span>/
            <span class="d-flex align-center px-1 text--secondary">
              <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                               icon-class="mouseButton"></mrc_ess_svgIcon>
              {{ $t('label_button') }}
            </span>
          </v-sheet>

          <v-sheet width="24vw"
                   class="text--secondary">
            {{ $t('label_Short_code') }}
          </v-sheet>
          <!-- <div class="is_show">{{ $t('label_Whether_to_enable') }}</div> -->
        </v-sheet>
        <v-treeview hoverable
                    open-on-click
                    transition
                    item-key="uuid"
                    item-children="sub"
                    expand-icon="arrow_drop_down"
                    :items="productData">
          <template v-slot:label="{ item }">
            <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                             icon-class="diamond02"
                             v-if="item.type == 3"></mrc_ess_svgIcon>
            <mrc_ess_svgIcon style="font-size: 24px;margin-right: 5px"
                             icon-class="mouseButton"
                             v-if="item.type == 4"></mrc_ess_svgIcon>{{ INT(item.names) }}
          </template>
          <template v-slot:append="{ item }">
            <v-sheet width="24vw"
                     class="d-flex align-center justify-space-between">
              {{ item.shortcode }}
              <mrc_ess_showClientType :iconList="item.clientType"></mrc_ess_showClientType>
              <menu-list :list="list(item)"
                         v-if="item.type != 4"
                         v-btnAuth="
                  item.type == 2
                    ? ['edit-moduless', 'delete-moduless']
                    : item.type == 3
                    ? ['edit-function', 'delete-function']
                    : item.type == 4
                    ? ['edit-button', 'delete-button']
                    : item.type == 1
                    ? ['edit-product', 'view-product']
                    : false
                "
                         @handleClick="handleClick($event, item)">
                <template v-slot:showAction>
                  <v-icon>mdi-dots-vertical</v-icon>
                </template>
              </menu-list>
            </v-sheet>
          </template>
        </v-treeview>
        <!-- <moduleList
          v-for="(item, index) in productData"
          class="product213 mx-8 mb-4"
          :key="index"
          @delData="delData"
          :obj="item"
        ></moduleList> -->
      </v-card-text>
    </v-skeleton-loader>
  </v-card>
  <router-view v-else></router-view>
</template>

<script>
import { get_list, get_del, get_func_del } from '@/service/api/func_module'
import moduleList from './moduleList'
export default {
  components: { moduleList },
  props: {},
  data () {
    return {
      showSkeleton: false,
      productData: [],
    }
  },
  computed: {
    addList () {
      return [
        {
          name: this.$t('label_A_new_module'),
          page_name: 'module_add',
          show: this.$store.state.btnPermission.includes('add-module'),
        },
        {
          name: this.$t('label_New_features'),
          page_name: 'add_func',
          show: this.$store.state.btnPermission.includes('add-function'),
        },
      ]
    },
    list () {
      return (obj) => {
        return [
          {
            type: 'view',
            name: this.$t('label_View'),
            show:
              obj.type == 2
                ? this.hasBtn('view-module')
                : obj.type == 3
                  ? this.hasBtn('view-function')
                  : obj.type == 4
                    ? this.hasBtn('view-button')
                    : obj.type == 1
                      ? this.hasBtn('view-product')
                      : false,
          },
          {
            type: 'edit',
            name: this.$t('label_Edit'),
            show:
              obj.type == 2
                ? this.hasBtn('edit-module')
                : obj.type == 3
                  ? this.hasBtn('edit-function')
                  : obj.type == 4
                    ? this.hasBtn('edit-button')
                    : obj.type == 1
                      ? this.hasBtn('edit-product')
                      : false,
          },
          {
            type: 'del',
            name: this.$t('label_delete'),
            show:
              obj.type == 2
                ? this.hasBtn('delete-module')
                : obj.type == 3
                  ? this.hasBtn('delete-function')
                  : obj.type == 4
                    ? this.hasBtn('delete-button')
                    : false,
          },
        ]
      }
    },
  },
  async created () {
    await this.getBtnPermissionList()
  },
  async mounted () {
    if (this.$route.name == 'module_func_manage') {
      this.showSkeleton = true
      const list = await get_list()
      this.productData = list.data
      this.showSkeleton = false
    }
  },
  methods: {
    delData (uuid) {
      this.Recursion(this.productData, uuid)
    },
    Recursion (arr, uuid) {
      if (arr.length <= 0) return ''
      arr.forEach((item, index) => {
        if (item.uuid == uuid) {
          arr.splice(index, 1)
        } else {
          if (item.sub) {
            this.Recursion(item.sub, uuid)
          }
        }
      })
    },
    handleClick ({ item }, obj) {
      if (item.type == 'view') {
        let pgae_name = ''
        if (obj.type == 2) {
          pgae_name = 'module_detail'
        } else if (obj.type == 3) {
          pgae_name = 'func_detail'
        } else if (obj.type == 4) {
          pgae_name = 'func_detail'
        } else if (obj.type == 1) {
          pgae_name = 'product_detail'
        }
        this.$store.commit('set_subPage_name', obj.names)
        this.$store.commit('set_uuid', obj.uuid)
        this.$store.commit('set_iconstatus', true)
        this.$router.push({
          name: pgae_name,
          params: {
            name: obj.names,
            uuid: obj.uuid,
          },
        })
      }
      // 编辑
      if (item.type == 'edit') {
        this.edit(obj.names, obj.uuid, obj.sub, obj.type)
      }
      if (item.type == 'del') {
        this.del(obj.uuid, obj.type)
      }
    },
    edit (name, uuid, hasChild, type) {
      let pgae_name = ''
      if (type == 2) {
        pgae_name = 'module_detail'
      } else if (type == 3) {
        pgae_name = 'func_detail'
      } else if (type == 4) {
        pgae_name = 'func_detail'
      } else if (type == 1) {
        pgae_name = 'product_detail'
      }
      this.$store.commit('set_subPage_name', name)
      this.$store.commit('set_uuid', uuid)
      this.$store.commit('set_iconstatus', false)
      this.$router.push({
        name: pgae_name,
        params: {
          name,
          uuid,
        },
      })
    },
    del (uuid, type) {
      this.$myConfirm({
        title: this.$t('message_tips'),
        content: this.$t('message_Confirm_the_deletion'),
      })
        .then(async () => {
          // console.log(123)
          if (type == 2) {
            // 删除模块
            const del = await get_del({ uuid })
            if (del.code == 200) {
              this.$Message({
                text: this.$t('message_The_deletion_was_successful'),
                color: 'rgba(0,0,0,0.78)',
              })
              this.is_del = false
              this.delData(uuid)
            }
          }
          if (type == 3 || type == 4) {
            // 删除功能
            const del = await get_func_del({ uuid })
            if (del.code == 200) {
              this.$Message({
                text: this.$t('message_The_deletion_was_successful'),
                color: 'rgba(0,0,0,0.78)',
              })
              this.is_del = false
              this.delData(uuid)
            }
          }
        })
        .catch(() => {
          // console.log(456)
        })
    },
  },
  watch: {
    async $route (val) {
      if (val.name === 'module_func_manage') {
        this.showSkeleton = true
        const list = await get_list()
        this.productData = list.data
        this.showSkeleton = false
      }
    },
  },
}
</script>

<style scoped>
.moduleFun {
  /* margin-top: 50px; */
}
.btnGroup {
  position: relative;
}
.addBtn {
  color: #fff;
  position: absolute;
  top: -80px;
  right: 10px;
  transform: rotateZ(45deg);
}
.product213:nth-child(1) {
  margin-top: -30px;
}

/deep/ .v-treeview-node {
  margin-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}

/* /deep/ .v-treeview {
  border-radius: 8px;
} */
/deep/ .v-treeview-node__root:first-of-type {
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom: none;
  height: 60px;
}
/deep/ .v-treeview-node__children .v-treeview-node,
/deep/ .v-treeview-node__children .v-treeview-node__root {
  border-bottom: none;
  margin-bottom: 0;
  border-radius: inherit;
}
/deep/
  .v-treeview-node__children:last-child
  .v-treeview-node:last-child
  .v-treeview-node__root:last-child {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
/deep/ .v-treeview-node__root:last-child {
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
}
</style>
